var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('PatientList',{attrs:{"patients":_vm.patients,"totalDocs":_vm.totalDocs,"page":_vm.page,"noDataText":_vm.noDataText},on:{"fetchList":_vm.getPatientsList,"viewPatientDetail":_vm.patientDetail}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }